import script from "./j-steps-item.vue?vue&type=script&lang=js"
export * from "./j-steps-item.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__